import { ContentLoader, Grid, ServiceCard } from '@raskrask-dk/rr-components'
import { t } from 'i18next'
import { Props, StyledCompanyTypeCards } from '.'
import LeadIcon from '../../../assets/icons/company/Lead.svg'
import OneOffIcon from '../../../assets/icons/company/OneOff.svg'
import { ReactElement } from 'react'
import { ProductsCompany } from '@raskrask-dk/bookingflow-state-machine'

const CompanyTypeCards = ({
    isLoading,
    productsHandler,
}: Props): ReactElement => {
    const loadingArray = Array.from(Array(4).keys())

    const initialLoading = loadingArray.map((_num, key) => (
        <ContentLoader key={key} component="ServiceCard" />
    ))

    const companyTypesIcons: Record<ProductsCompany, string> = {
        CompanyLead: LeadIcon,
        Booking: OneOffIcon,
    }

    const companyCards = productsHandler.available.map((product, key) => (
        <ServiceCard
            buttonText={t('common:choose')}
            data-cy={`companyServiceBtn_${key + 1}`}
            disabled={false}
            icon={companyTypesIcons[product]}
            key={key}
            name={t(`common:companytypes.${product.split('_').join('')}`)}
            onClick={() => productsHandler.onClick(product)}
        />
    ))

    return (
        <StyledCompanyTypeCards>
            <Grid
                autoFlow={{
                    '@mobile': 'row',
                    '@desktop': 'dense',
                }}
                gap={{ '@mobile': 16, '@desktop': 32 }}
            >
                {isLoading ? initialLoading : companyCards}
            </Grid>
        </StyledCompanyTypeCards>
    )
}

export default CompanyTypeCards
